import { render, staticRenderFns } from "./CatalogGridPage.vue?vue&type=template&id=ea032e92&"
import script from "./CatalogGridPage.vue?vue&type=script&lang=js&"
export * from "./CatalogGridPage.vue?vue&type=script&lang=js&"
import style0 from "./CatalogGridPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports